import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Spin, PageHeader, Space, Typography, Input } from "antd";
import queryString from "query-string";
import { MoreOutlined, SearchOutlined } from "@ant-design/icons";

import { Table, MultiDropdown, SingleDropdown } from "../../components";
import { getUrl, requests } from "../../globals/requests";
import { Container, TableContainer, SpaceBetween } from "./styles";
import { helpers } from "../../utils";
import { transactionsColumn } from "./helpers";

let buff = {};
function UserTransactions(props) {
  const history = useHistory();

  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [user, setUser] = useState(history?.location?.state?.user);
  const [filterVals, setFilterVals] = useState({});

  const [loading, setLoading] = useState(false);

  let { userId } = useParams();

  function moreOptions(transaction) {
    history.push(`/dashboard/transactions/${transaction?._id}`);
  }

  transactionsColumn[transactionsColumn.length - 1].render = (saving) => (
    <MoreOutlined
      style={{ fontSize: "20px" }}
      onClick={() => moreOptions(saving)}
    />
  );

  useEffect(() => {
    async function getUser() {
      try {
        const url = `${getUrl("users")}/${userId}`;
        const response = await requests.getWithAuth(url);
        setUser(response.data);
      } catch (e) {
        helpers.displayMessage(e);
      }
    }

    getUser();
  }, [userId]);

  useEffect(() => {
    async function getTransactions() {
      try {
        const url = `${getUrl("users")}/${userId}/transactions`;
        setLoading(true);
        const query = queryString.parse(window.location.search);
        const response = await requests.getWithAuth(url, query);
        console.log(response.data);
        setLoading(false);
        // alert(JSON.stringify(response.data));
        setTransactions(response.data);
        setFilteredTransactions(response.data);
      } catch (e) {
        setLoading(false);
        helpers.displayMessage(e);
      }
    }

    getTransactions();
  }, [userId]);

  const onFilter = useCallback(
    (key, vals) => {
      const newFilter = {
        ...filterVals,
        [key]: vals,
      };
      setFilterVals(newFilter);

      let buff = [...transactions];

      Object.entries(newFilter).forEach((els) => {
        const [key, val] = els;
        const isArray = Array.isArray(val);
        if (isArray && !val?.length) return;
        buff = buff.filter((el) => {
          return Array.isArray(val) ? val.includes(el[key]) : el[key] === val;
        });
      });

      setFilteredTransactions(buff);
    },
    [filterVals, transactions]
  );

  function searchTransactions(e) {
    const searchValue = e.target.value;
    if (transactions.length === 0) {
      return;
    }

    if (buff[searchValue]) {
      setFilteredTransactions(buff[searchValue]);
    } else {
      const filteredData = filteredTransactions.filter((el) => {
        const isInReference = el.reference
          .toLowerCase()
          .includes(searchValue.toLowerCase());

        return isInReference;
      });
      setFilteredTransactions(filteredData);
      buff = { ...buff, [searchValue]: filteredData };
    }
  }

  const totalAmount = useMemo(() => {
    return filteredTransactions.reduce((acc, cv) => acc + cv.amount, 0);
  }, [filteredTransactions]);

  const totalFees = useMemo(() => {
    return filteredTransactions.reduce((acc, cv) => acc + cv.fees, 0);
  }, [filteredTransactions]);

  if (loading) {
    return (
      <div className="spin-contain">
        <Spin delay={100} size="large" tip="Getting Transactions..."></Spin>
      </div>
    );
  }

  return (
    <Container>
      <PageHeader
        className="site-page-header"
        onBack={() => history.goBack()}
        title="Transactions"
        subTitle={`${user?.first_name + " " + user?.last_name}'s Transactions`}
      />
      <Space direction="vertical" size="large">
        <Space direction="horizontal" size="large">
          <div>
            <Typography.Title level={5} style={{ margin: 0 }}>
              Total Amount
            </Typography.Title>
            <Typography.Title level={3} style={{ margin: 0 }}>
              {helpers.toCurrency(totalAmount)}
            </Typography.Title>
          </div>
          <div>
            <Typography.Title level={5} style={{ margin: 0 }}>
              Total Fees
            </Typography.Title>
            <Typography.Title level={3} style={{ margin: 0 }}>
              {helpers.toCurrency(totalFees)}
            </Typography.Title>
          </div>
          {!!totalAmount && (
            <div>
              <Typography.Title level={5} style={{ margin: 0 }}>
                Fees Percentage
              </Typography.Title>
              <Typography.Title level={3} style={{ margin: 0 }}>
                {((totalFees * 100) / totalAmount).toFixed(2)}%
              </Typography.Title>
            </div>
          )}
        </Space>
        <Space>
          <MultiDropdown
            label="Status"
            options={["success", "pending", "failed"]}
            onChange={(val) => onFilter("status", val)}
          />
          <MultiDropdown
            label="ProcessedBy"
            options={["paystack", "monnify", "stashboxwallet"]}
            onChange={(val) => onFilter("processedBy", val)}
          />
          <MultiDropdown
            label="Action"
            options={["withdraw", "send", "deposit"]}
            onChange={(val) => onFilter("action", val)}
          />
        </Space>
        <SpaceBetween>
          <div className="org-inpup-container">
            <Input
              size="large"
              onChange={searchTransactions}
              placeholder="Search Reference"
              prefix={<SearchOutlined />}
            />
          </div>
        </SpaceBetween>
        <TableContainer>
          <Table
            columns={transactionsColumn}
            dataSource={filteredTransactions}
          />
        </TableContainer>
      </Space>
    </Container>
  );
}

export default UserTransactions;
